import { d as deprecated } from './6cf04c83.mjs';

function clone(object) {
  deprecated("o_util.core.clone", "use native Object.from instead");
  return Object.create(object);
}
function extend(object1, object2, overwrite, cloneObj) {
  const replace = typeof overwrite === "boolean" ? overwrite : true;
  const doClone = typeof cloneObj === "boolean" ? cloneObj : false;
  const result = doClone ? Object.create(object1) : object1;
  Object.keys(object2 || {}).forEach((key) => {
    if (replace || !(key in result)) {
      result[key] = object2[key];
    }
  });
  return result;
}
function isPlainObject(object) {
  return !!object && Object.prototype.toString.call(object) === "[object Object]" && !object.nodeType && object !== object.window;
}
function isEmptyObject(object, inherited) {
  const properties = [];
  if (!inherited) {
    return Object.keys(object).length === 0;
  }
  for (const prop in object) {
    properties.push(prop);
  }
  return Object.keys(properties).length === 0;
}

export { isEmptyObject as a, clone as c, extend as e, isPlainObject as i };
/*                                 */
